/* global embeddedservice_bootstrap */
/* eslint-disable complexity */

// Environment configuration for Salesforce Embedded Messaging
const CHAT_CONFIG = {
	staging: {
		env: 'staging',
		orgId: '00DRu000001EGy9',
		deploymentName: 'B2C_Chat',
		siteUrl: 'https://dealertire--dtstaging.sandbox.my.site.com/ESWB2CChat1769117798377',
		scrtUrl: 'https://dealertire--dtstaging.sandbox.my.salesforce-scrt.com'
	},
	production: {
		env: 'production',
		orgId: '00D41000000VRVx',
		deploymentName: 'B2C_Chat',
		siteUrl: 'https://dealertire.my.site.com/ESWB2CChat1770752039792',
		scrtUrl: 'https://dealertire.my.salesforce-scrt.com'
	}
};

// Get environment and config once at module load
// Detect environment from hostname since chat.js runs in the browser
function getEnvironmentFromHostname() {
	const hostname = window.location.hostname;

	// Production domains
	if (hostname.includes('.sbx') || hostname.includes('.qa') || hostname.includes('demo.') || hostname.includes('.dev')) {
		return 'staging';
	}

	return 'production';
}

const currentEnv = getEnvironmentFromHostname();
const currentConfig = CHAT_CONFIG[currentEnv];

function initEmbeddedMessaging() {
	if (!window.embeddedservice_bootstrap) {
		console.error('Embedded Messaging bootstrap not loaded');

		return;
	}

	try {
		embeddedservice_bootstrap.settings.language = 'en_US';

		embeddedservice_bootstrap.init(
			currentConfig.orgId,
			currentConfig.deploymentName,
			currentConfig.siteUrl,
			{
				scrt2URL: currentConfig.scrtUrl
			}
		);
	} catch (err) {
		console.error('Error loading Embedded Messaging: ', err);
	}
}

// Helper to dispatch custom DOM events for RudderstackChatMixin compatibility
function dispatchChatEvent(eventName) {
	const event = new Event(eventName, {
		bubbles: true,
		cancelable: false
	});

	document.dispatchEvent(event);
}

// Track the last dealer code and URL to avoid duplicate updates
let lastDealerCode = null;
let lastUrl = null;

// Global function to update dealer code in chat prechat fields
window.updateChatDealerCode = function(dealerCode) {
	try {
		const currentUrl = window.location.href;

		// Only update if the dealer code or URL has changed
		if (dealerCode === lastDealerCode && currentUrl === lastUrl) {
			return;
		}

		if (window.embeddedservice_bootstrap && window.embeddedservice_bootstrap.prechatAPI) {
			// Split URL at the query string
			const splitIndex = currentUrl.indexOf('?');
			const urlPart1 = splitIndex !== -1 ? currentUrl.substring(0, splitIndex) : currentUrl;
			let urlPart2 = splitIndex !== -1 ? currentUrl.substring(splitIndex) : '';
			let urlPart3 = '';

			// Split urlPart2 if it exceeds 255 characters
			if (urlPart2.length > 255) {
				urlPart3 = urlPart2.substring(255);
				urlPart2 = urlPart2.substring(0, 255);
			}

			// Truncate urlPart3 if it exceeds 255 characters (Salesforce field limit)
			if (urlPart3.length > 255) {
				urlPart3 = urlPart3.substring(0, 255);
			}

			// Update prechat fields with new dealer code
			const anonymousId = typeof window.getRudderstackAnonymousId === 'function'
				? window.getRudderstackAnonymousId()
				: '';
			const prechatFields = {
				'Dealer_Code': dealerCode || '',
				'Visited_Pages': urlPart1,
				'Visited_Pages_Part_2': urlPart2,
				'Visited_Pages_Part_3': urlPart3,
				'Web_Tracking_Id': anonymousId || ''
			};

			embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(prechatFields);

			// Update the trackers
			lastDealerCode = dealerCode;
			lastUrl = currentUrl;
		}
	} catch (err) {
		console.error('Error updating chat dealer code:', err);
	}
};

// Set up prechat data when chat is ready (B2C only)
window.addEventListener('onEmbeddedMessagingReady', function() {
	try {
		// Get dealer code from dataLayer (injected by server)
		const dataLayer = window.dataLayer && window.dataLayer[0] ? window.dataLayer[0] : {};
		const dealerCode = dataLayer.dealerCode || '';

		// Set initial prechat fields
		window.updateChatDealerCode(dealerCode);

	} catch (err) {
		console.error('Error updating chat dealer code:', err);
	}
});

// ============================================================================
// Rudderstack Event Bridge
// Dispatch custom DOM events for RudderstackChatMixin compatibility
// ============================================================================

// Chat button clicked -> CHAT_INITIATED
window.addEventListener('onEmbeddedMessagingButtonClicked', function() {
	dispatchChatEvent('onHelpButtonClick');
});

// Conversation started -> CHAT_SESSION_STARTED
window.addEventListener('onEmbeddedMessagingConversationStarted', function() {
	dispatchChatEvent('onChatRequestSuccess');
});

// Message sent -> CHAT_SESSION_INTERACTION (Agent or Customer)
window.addEventListener('onEmbeddedMessageSent', function(e) {
	try {
		const detail = e.detail || {};
		const conversationEntry = detail.conversationEntry || {};
		const sender = conversationEntry.sender || {};
		const role = sender.role || '';

		// Determine if message is from agent/bot or customer
		if (role === 'EndUser') {
			// Customer sent a message
			dispatchChatEvent('onChasitorMessage');
		} else if (role === 'Agent' || role === 'Chatbot' || role === 'System') {
			// Agent or bot sent a message
			dispatchChatEvent('onAgentMessage');
		}
	} catch (err) {
		console.error('Error handling onEmbeddedMessageSent:', err);
	}
});

// Chat window closed -> CHAT_SESSION_CLOSED
window.addEventListener('onEmbeddedMessagingWindowClosed', function() {
	// Clear tracking variables to prevent stale data on next chat session
	lastDealerCode = null;
	lastUrl = null;

	dispatchChatEvent('afterDestroy');
});

// Load the bootstrap script
if (!window.embeddedservice_bootstrap) {
	const script = document.createElement('script');

	script.setAttribute('type', 'text/javascript');
	script.setAttribute('src', `${currentConfig.siteUrl }/assets/js/bootstrap.min.js`);
	script.onload = function() {
		initEmbeddedMessaging();
	};
	document.body.appendChild(script);
} else {
	initEmbeddedMessaging();
}
